import styled from 'styled-components';

export const Container = styled.div``;

export const Header = styled.div`
  background-color: #2C3333;
  height: 150px;
  text-align: center;
`;

export const HeaderText = styled.h1`
  margin: 0;
  padding: 0;
  color: #CBE4DE;
  padding-top: 30px;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  height: 100vh;
  margin-bottom: 50px;
  background-color: #2E4F4F;
  align-items: center;
`;